/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ikh_Donotsendinvoice3Inputs */

const en__field_ikh_donotsendinvoice3 = /** @type {(inputs: _Field_Ikh_Donotsendinvoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not send Invoice`)
};

const de__field_ikh_donotsendinvoice3 = /** @type {(inputs: _Field_Ikh_Donotsendinvoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rechnung versenden`)
};

/**
* | output |
* | --- |
* | "Do not send Invoice" |
*
* @param {_Field_Ikh_Donotsendinvoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_ikh_donotsendinvoice3 = /** @type {((inputs?: _Field_Ikh_Donotsendinvoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ikh_Donotsendinvoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_ikh_donotsendinvoice3(inputs)
	return de__field_ikh_donotsendinvoice3(inputs)
});
export { _field_ikh_donotsendinvoice3 as "_field_ikh_doNotSendInvoice" }